import React from "react"

import {
  Award,
  ExternalLink,
  Grip,
  Headset,
  Leaf,
  UsersRound,
} from "lucide-react"

export const fr = {
  title: "Politique RH : notre engagement pour la mixité",
  description:
    "Engagés en matière de responsabilité sociétale, nous menons une politique de mixité, en mettant tout en œuvre pour intégrer et faire évoluer, dans les meilleures conditions, l’ensemble de tous nos collaborateurs et collaboratrices",
  asideMenu: [
    {
      title: "Carrières",
      icon: <ExternalLink className="size-4 stroke-fehr-500" />,
      to: "https://www.talentdetection.com/fehr/65771-hdMCpqja1C/accueil",
      target: "_blank",
    },
    {
      title: "Nos Valeurs",
      to: "values",
    },
    {
      title: "Histoire",
      to: "history",
    },
    {
      title: "Recherche & Développement",
      to: "rd",
    },
    {
      title: "Ressources Humaines",
      to: "rh",
    },
  ],
  history: {
    heroTitle: "Une histoire familiale, des valeurs fortes",
    heroSubtitle:
      "FEHR, spécialiste du béton prêt à l'emploi et préfabriqué, aux valeurs solides : famille, service client, innovation ,environnement, qualité.",
    main_content: [
      "Producteur engagé pour apporter des solutions minérales et écologiques en Europe pour la rénovation et la construction des bâtiments du futur, FEHR est une entreprise familiale et indépendante depuis 1960, avec 10 centrales dans l’Est de la France et 4 sites de production d’éléments préfabriqués.",
      "Visionnaire et responsable, le groupe FEHR se distingue par son engagement écologique, son service sur-mesure et son expertise technologique du hors-site.",
      "Certifié ISO 9001–14001–45001 et répondant à l'attestation sociétale 26000, le groupe emploie près de 600 personnes et propose à travers toute l’Europe une gamme de produits bas carbone comprenant du béton prêt à l’emploi, une gamme complète de mur Précoffré®, du Béton de Terre Crue, la façade FOBB Fehr Ossature Bois Béton®, la prédalle et le panneau de bardage FClad® en Béton Fibré Ultra Hautes Performances.",
      "Des services associés tels que la logistique, la location d’engins et des équipes d’assemblage complètent la gamme de produits.",
      "Basé sur le respect de l’environnement, FEHR développe des solutions toujours plus innovantes de haute technicité et respectueuses du bien-être de ses clients.",
    ],
    valuesTitle: "Nos Valeurs",
    valuesIntro:
      "Bien plus qu'un code éthique, nos valeurs, partagées par l’ensemble de nos collaborateurs, sont le socle qui soutient l’ensemble de nos actions, nos décisions et notre vision stratégique. Elles créent du sens, fédèrent et garantissent la pérennité et la crédibilité de notre groupe dans un environnement en constante évolution.",
    columnsData: [
      {
        title: "Famille",
        items: ["proximité", "entraide et esprit d'équipe", "respect"],
        icon: UsersRound,
      },
      {
        title: "Service client",
        items: ["personnalisation", "partenariats", "agilité"],
        icon: Headset,
      },
      {
        title: "Innovation",
        items: ["digital", "technicité", "pionnier"],
        icon: Grip,
      },
      {
        title: "Environnement",
        items: ["éco engagée", "producteurs locaux", "éco circulaire"],
        icon: Leaf,
      },
      {
        title: "Qualité",
        items: ["amélioration continue", "satisfaction client", "client"],
        icon: Award,
      },
    ],
    timelineTitle: "Notre histoire",
    sectionTitle: "Une ETI familiale aux valeurs solides et durables",
    paragraphs: [
      "Spécialisé dans les solutions béton, FEHR Groupe est une entreprise familiale et indépendante depuis 1960, avec 9 centrales dans l’Est de la France et 4 sites de production dont 1 en Allemagne. Certifié ISO 14001– ISO 9001 - ISO 45001, le groupe emploie près de 600 personnes et propose à travers toute l’Europe une gamme de produits comprenant du béton prêt à l’emploi, des éléments en béton préfabriqués comme le mur Précoffré®, la prédalle et le panneau de bardage F(Clad)® en béton fibré ultra hautes performances.",
      "Ses services associés tels que la logistique, la location d’engins et des équipes d’assemblage complètent la gamme de produits. basé sur le respect de l’environnement, FEHR développe des solutions toujours plus innovantes de haute technicité et respectueuses du bien-être de ses clients.",
      "Véritable acteur européen, le groupe Fehr accompagne ses clients dans leur développement à l’international avec des systèmes constructifs maîtrisés, innovants et une logistique adaptée.",
    ],
    imageAlt: "FEHR Group : la famille au complet",
    story: [
      "En 1960, Marthe et Albert FEHR créent une petite entreprise de construction à Reichshoffen en Alsace.",
      "Cette entreprise qui ne compte que deux personnes lors de sa création, réalise ses premiers chantiers et se développe de façon harmonieuse en se spécialisant dans les métiers du béton.",
    ],
    footerTitle: "une histoire que l’on écrit ensemble depuis 1960",
  },
  rd: {
    title: "Recherche & Développement",
    subtitle: "L’innovation : ancrée dans la culture de l’entreprise",
    content:
      "L'innovation est au centre des préoccupations du groupe, visant à relever les défis climatiques et constructifs. Cette orientation se concrétise notamment par l'obtention d'avis techniques, le dépôt de brevets, l'adoption de nouvelles technologies et le développement de produits novateurs. Ces actions sont destinées à répondre de manière proactive aux demandes changeantes du marché et des clients, tout en accélérant la transformation des métiers et des offres de l'entreprise.",
    labtitle: "Laboratoire Béton",
    labSubtitle:
      "La conformité technique de nos produits est garantie par des contrôles permanents :",
    labArr: [
      "Contrôle de qualité du béton frais",
      "Étude et développement de formulations",
      "Tests de durcissement et de résistance",
      "Analyse de durabilité",
      "Contrôle de qualité des matériaux",
    ],
  },
  hr: {
    heroTitle: "Ressources Humaines",
    buttonText: "Nos offres d'emploi",
    sections: [
      {
        title: "Notre Politique RH",
        texts: [
          "Engagés en matière de responsabilité sociétale, nous menons une politique de mixité, en mettant tout en œuvre pour intégrer et faire évoluer, dans les meilleures conditions, l’ensemble de tous nos collaborateurs et collaboratrices.",
          "Notre secteur progresse vers plus de mixité, nos métiers, historiquement très masculins, sont aujourd’hui aussi bien exercés par des femmes que par des hommes.",
          "Nous veillons à l'épanouissement professionnel des salariés en offrant des opportunités de formation et de développement. Cela permet non seulement de renforcer les compétences des collaborateurs, mais aussi de répondre aux évolutions du marché et aux besoins de l’entreprise.",
        ],
        indicators: [
          {
            name: "FEHR Technologies Rhône Alpes",
            indicators: [
              "Ecart de rémunération femme/homme : Non calculable",
              "Ecart du taux d'augmentation femme/homme : 15/35",
              "Ecart relatif au % de salariés ayant bénéficié d'une augmentation dans l'année suivant leur retour de congé maternité : 15/15",
              "Ecart relatif au nombre de salariés du sexe sous représenté parmi les 10 plus hautes rémunérations : 05/10",
            ],
            note: "Note globale : 35 / 60",
          },
          {
            name: "FEHR Technologies Région Rhénane",
            indicators: [
              "Ecart de rémunération femme/homme : Non calculable",
              "Ecart du taux d'augmentation femme/homme : 35/35",
              "Ecart relatif au % de salariés ayant bénéficié d'une augmentation dans l'année suivant leur retour de congé maternité : 15/15",
              "Ecart relatif au nombre de salariés du sexe sous représenté parmi les 10 plus hautes rémunérations : 0/10",
            ],
            note: "Note globale : 50 / 60",
          },
          {
            name: "FEHR Technologies Ile de France",
            indicators: [
              "Ecart de rémunération femme/homme : Non calculable",
              "Ecart du taux d'augmentation femme/homme : 35/35",
              "Ecart relatif au % de salariés ayant bénéficié d'une augmentation dans l'année suivant leur retour de congé maternité : 15/15",
              "Ecart relatif au nombre de salariés du sexe sous représenté parmi les 10 plus hautes rémunérations : 0/10",
            ],
            note: "Note globale : 50 / 60",
          },
          {
            name: "FEHR Groupe",
            indicators: [
              "Ecart de rémunération femme/homme : Non calculable",
              "Ecart du taux d'augmentation femme/homme : 35/35",
              "Ecart relatif au % de salariés ayant bénéficié d'une augmentation dans l'année suivant leur retour de congé maternité : Non calculable",
              "Ecart relatif au nombre de salariés du sexe sous représenté parmi les 10 plus hautes rémunérations : 5/10",
            ],
            note: "Note globale : 40 / 45",
          },
        ],
      },
      {
        title: "Qualité de Vie au travail",
        texts: [
          "Nous nous engageons à fournir à l'ensemble de nos salariés une Qualité de Vie au travail en assurant des conditions de travail favorables, qu'il s'agisse de la sécurité, ou de l'équilibre entre vie professionnelle et personnelle. Ainsi, nous proposons :",
        ],
        list: [
          "des horaires variables, avec des plages fixes, dans tous les services où cela est possible",
          "1 jour de télétravail par semaine ou une semaine consécutive dans le mois, dans tous les services où cela est possible afin de limiter notamment les temps de transport",
        ],
      },
      {
        title: "Mobilité et cooptation",
        texts: [
          "L’entreprise encourage la mobilité interne, A ce titre, si un salarié souhaite postuler sur un poste ouvert au recrutement, il pourra le faire à tout moment et sa candidature sera étudiée avec attention.",
          "Chaque salarié est un ambassadeur de l’entreprise. Par conséquent, si un salarié recommande un candidat issu de son entourage pour un poste ouvert au recrutement et que le profil est retenu, une prime de cooptation lui sera versée, dès la validation de sa période d’essai.",
        ],
      },
      {
        title: "Votre Carrière",
        texts: [
          "La gestion des talents est au cœur de notre politique RH. Cela inclut le recrutement de profils correspondant aux besoins de l’entreprise et à ses valeurs, ainsi que leur intégration efficace au sein des équipes. L’arrivée d’un nouveau collaborateur est toujours un évènement, c’est pourquoi, chez FEHR, nous la préparons en amont afin que le parcours d’intégration soit totalement personnalisé au poste. Les premiers pas de cette grande aventure seront rythmés ainsi :",
        ],
        list: [
          "Une journée d’accueil, pour découvrir le groupe",
          "Une présentation digitale de nos outils",
          "Son fonctionnement, son histoire et ses valeurs",
          "Une formation personnalisée selon le poste intégré",
        ],
      },
    ],
  },
}
